module.exports = __webpack_public_path__ + "static/yachtsafe-extraimg1@2x-min-d96a4a8c3236d856fcf85ecd29ca29f1.png";